// sessionStorage key used to persist punchup context across SPA-internal
// navigations and hard reloads at sub-paths that no longer carry ?isPunchup=true.
export const PUNCHUP_SESSION_KEY = 'isPunchup';

// sessionStorage key for the in-app green-zone gate, persisted alongside the
// punchup flag so a hard reload at a sub-path keeps a gated venue on the green UI.
export const GREEN_ZONE_SESSION_KEY = 'greenZone';
